// src/utils/geometryHelpers.js

/**
 * 解析AI返回的几何参数
 */
export const parseGeometryParams = (aiResponse) => {
  // 如果AI返回结构化数据，直接使用
  if (aiResponse.geometry_params) {
    return aiResponse.geometry_params;
  }
  
  // 否则从回复文本中提取（简单解析）
  const reply = aiResponse.reply || '';
  
  // 尝试匹配立方体
  const cubeMatch = reply.match(/(立方体|长方体).*?(\d+(\.\d+)?)\s*mm/);
  if (cubeMatch) {
    return {
      type: 'cube',
      size: parseFloat(cubeMatch[2]),
      label: `立方体 ${cubeMatch[2]}mm`
    };
  }
  
  // 尝试匹配圆柱体
  const cylinderMatch = reply.match(/(圆柱|圆柱体).*?直径\s*(\d+(\.\d+)?)\s*mm.*?高\s*(\d+(\.\d+)?)\s*mm/);
  if (cylinderMatch) {
    return {
      type: 'cylinder',
      radius: parseFloat(cylinderMatch[2]) / 2,
      height: parseFloat(cylinderMatch[4]),
      label: `圆柱体 直径${cylinderMatch[2]}mm 高${cylinderMatch[4]}mm`
    };
  }
  
  // 默认返回空
  return null;
};

/**
 * 根据参数生成Three.js几何体
 */
export const createGeometry = (params) => {
  if (!params) return null;
  
  const { type } = params;
  
  switch(type) {
    case 'cube':
      const size = params.size || 50;
      return {
        geometryType: 'BoxGeometry',
        args: [size, size, size],
        params
      };
      
    case 'cuboid':
      return {
        geometryType: 'BoxGeometry',
        args: [
          params.length || 40,
          params.width || 30,
          params.height || 50
        ],
        params
      };
      
    case 'cylinder':
      return {
        geometryType: 'CylinderGeometry',
        args: [
          params.radius || params.diameter / 2 || 15,
          params.radius || params.diameter / 2 || 15,
          params.height || 50,
          32
        ],
        params
      };
      
    case 'polygon_prism':
      return {
        geometryType: 'CylinderGeometry',
        args: [
          params.radius || params.inscribed_diameter / 2 || 15,
          params.radius || params.inscribed_diameter / 2 || 15,
          params.height || 50,
          params.sides || 6
        ],
        params
      };
      
    case 'sphere':
      return {
        geometryType: 'SphereGeometry',
        args: [
          params.radius || 25,
          32,
          16
        ],
        params
      };
      
    case 'hole':
      // 孔的3D表示（圆柱体）
      const holeRadius = (params.diameter || 4.0) / 2;
      const holeHeight = params.depth || 8.0;
      return {
        geometryType: 'CylinderGeometry',
       args: [holeRadius, holeRadius, holeHeight, 32],
       params  // 和其他 case 保持一致
      };
    default:
      return null;
  }
};

/**
 * 毫米转Three.js单位（假设1单位=1mm）
 */
export const mmToUnits = (mm) => {
  return mm; // 1:1比例，可根据需要调整
};

/**
 * 获取几何体的尺寸信息文本
 */
export const getDimensionsText = (params) => {
  if (!params) return '无几何参数';
  
  const { type } = params;
  
  switch(type) {
    case 'cube':
      const size = params.size || 50;
      return `立方体\n边长: ${size}mm`;
      
    case 'cylinder':
      const radius = params.radius || 25;
      const height = params.height || 50;
      return `圆柱体\n直径: ${radius * 2}mm\n高度: ${height}mm`;
      
    case 'sphere':
      return `球体\n半径: ${params.radius || 25}mm`;
      
    default:
      return JSON.stringify(params, null, 2);
  }
};